import * as types from '../actions/types';

const defaultState = {};

const rulesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_RULES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default rulesReducer;
